export default __webpack_public_path__ + "static/media/thumb07_newsletter.74608337.png";